import customHeaders, { getSpace } from '../../../../common/headers'
import { MoonLoader } from 'react-spinners'
import { CardExecutor } from '../../../../components/CardsComponents/CardExecutor/CardExecutor'
import { useState, useEffect } from 'react'
import { InputSearch, NoDataContent, Tabs } from "@lk-gtcom/ecomlab-components"
import { ButtonWithIcon } from '../../../../components/Buttons/ButtonWithIcon/ButtonWithIcon'
import useGeneralStore from '../../../../store/general'
import sort_icon from './img/sort_icon.svg';
import sort_icon_top from './img/sort_icon_top.svg';
import { ModalComponent } from '../../../../components/Modal/ModalComponent/ModalComponent'
import { useResponseHandler } from '../../../../common/auth'
import './ModalAddExecutor.scss'

const btn_tab = [
    { label: 'Добавить', value: 'add' },
    { label: 'Добавленные', value: 'added' }
]

const ModalAddExecutor = ({
    addNewMember,
    deleteMember,
    projectId,
    ticket = false,
    crm = false,
    close = () => { }
}) => {

    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const { handleTableResponse, handleRequestError } = useResponseHandler();

    const [executorOptions, setExecutorOptions] = useState([])
    const [executorSearchValue, setExecutorSearchValue] = useState('')
    const [load, setLoad] = useState(false)
    const [loadGlobal, setLoadGlobal] = useState(false)
    const [sort, setSort] = useState(null)
    const [pageValue, setPageValue] = useState(btn_tab[0].value)

    const fetchPossibleAttendees = (pageValue, abortController = new AbortController()) => {

        setLoad(true)
        const params_sort = `?can_be_add=${pageValue === 'add' ? 'true' : 'false'}&search=${executorSearchValue}&order_param_direction=${sort == 'ASC' ? 'desc' : 'asc'}`

        let url = ` https://portals.ecomru.ru/api/v3/tasks/${projectId}/attendees${params_sort}`
        if (crm) {
            url = ` https://portals.ecomru.ru/api/crm/projects/${projectId}/attendees${params_sort}`;
        }
        if (ticket) {
            url = ` https://portals.ecomru.ru/api/ticket/project/${projectId}/attendees${params_sort}`
        }
        url = url + params_sort

        fetch(url, { headers, signal: abortController.signal })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error('bad attendees response');
                }
            })
            .then((json) => {
                setExecutorOptions(json ? json : [])
                setLoad(false)
            })
            .catch((e) => {
                setLoad(false)
                console.error(e)
            })
            .finally((e) => {
                if (abortController.signal.aborted) return
                setLoadGlobal(false)
                setLoad(false)
            })
    };

    useEffect(() => {
        const abortController = new AbortController()
        fetchPossibleAttendees(pageValue, abortController)
        return () => abortController.abort();
    }, [sort, executorSearchValue, pageValue]);

    return (
        <ModalComponent
            title='Список сотрудников'
            onClose={close}
            style={{
                maxWidth: '880px'
            }}
            loading={loadGlobal}
            isNoData={!executorOptions.length}
            titleNoData='Нет сотрудников по заданным параметрам'
            child={
                <div className='modal-add-executor'>
                    <div className='modal-add-executor__toolbar'>
                        <ButtonWithIcon
                            size='m'
                            icon={sort == 'ASC' ? sort_icon : sort_icon_top}
                            onClick={(e) => setSort(sort == 'ASC' ? 'DESC' : 'ASC')}
                        />

                        <InputSearch
                            maxWidth='100%'
                            placeholder='Имя или почта сотрудника'
                            value={executorSearchValue}
                            onChange={setExecutorSearchValue} />
                    </div>

                    <Tabs
                        tabs={btn_tab}
                        stopRedirect
                        pageValue={pageValue}
                        setPageValue={(e) => setPageValue(e)}
                    />

                    {load ?
                        <div className='modal-add-executor__load' >
                            <MoonLoader
                                size={40}
                                color="#7b7b7b"
                                speedMultiplier={0.5}
                            />
                        </div>
                        :
                        <div className='modal-add-executor__content'>
                            {executorOptions.length > 0 ?
                                executorOptions?.map((props) => {
                                    if (pageValue == 'add') {
                                        return <CardExecutor
                                            {...props}
                                            status={false}
                                            addNewMember={(e) => {
                                                addNewMember(e?.[0])
                                                setTimeout(() => fetchPossibleAttendees(pageValue, []), 1000)
                                            }}
                                        />
                                    }
                                    if (pageValue == 'added') {
                                        return <CardExecutor
                                            {...props}
                                            status={true}
                                            addNewMember={(e) => {
                                                deleteMember(e?.[0])
                                                setTimeout(() => fetchPossibleAttendees(pageValue, []), 1000)
                                            }}
                                        />
                                    }
                                })
                                :
                                <NoDataContent
                                    description="Нет сотрудников по заданным параметрам"
                                    border={false}
                                    height={'400px'}
                                />
                            }
                        </div>
                    }
                </div>
            }
        />
    )
}

export { ModalAddExecutor }